import useSWR from 'swr'
import type { Fetcher } from 'swr'
import { client } from '~/api/client'
import { Schemas, getMemberByUserName } from '~/api/gen'

export const fetchGetMemberByUserName: Fetcher<
  Schemas.member_large_detail,
  [operation: 'getMemberByUserName', userName: string]
> = async ([, userName]) => {
  const res = await getMemberByUserName(client, {
    parameter: { user_name: userName },
  })
  if (res.type === 'error')
    throw new Error(`Failed to get member: ${res.raw.statusText}`)
  return res.data
}

export const useMember = (
  userName: string
): Schemas.member_large_detail | undefined => {
  const res = useSWR<
    Schemas.member_large_detail,
    Error,
    [operation: 'getMemberByUserName', userName: string]
  >(['getMemberByUserName', userName], fetchGetMemberByUserName)
  return res.data
}
